import { ImageSearch, getStaticProps } from '@public/ImageSearch'

export { getStaticProps }

export default ImageSearch
